import { get, httpDelete, patch, post } from "@readai/common/api";
import type {
  ContactGroup,
  ContactGroupsPatchBody,
  ContactGroupsPostBody,
  UserContactGroupSessionSharingRecordPostBody,
} from "@readai/common/types/contactGroups";

export const listContactGroups = async (): Promise<ContactGroup[]> => {
  return get(`/user-contact-groups`, {
    withCreds: true,
  });
};

export const getContactGroup = async (id: string): Promise<ContactGroup> => {
  return get(`/user-contact-groups/${id}`, {
    withCreds: true,
  });
};

export const createContactGroup = async (body: ContactGroupsPostBody) => {
  return post("/user-contact-groups", body, { withCreds: true });
};

export const deleteContactGroup = async (id: string) => {
  httpDelete(`/user-contact-groups/${id}`, {
    withCreds: true,
  });
};

export const patchContactGroup = async ({
  id,
  ...body
}: ContactGroupsPatchBody & { id: string }) => {
  return patch(`/user-contact-groups/${id}`, body, { withCreds: true });
};

export const postUserContactGroupSessionSharingRecord = async (
  body: UserContactGroupSessionSharingRecordPostBody,
) => {
  return post("/user-contact-groups/session-sharing-records", body, {
    withCreds: true,
  });
};
